import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("bspark_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const portalApi = axios.create({ baseURL: API });
portalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem("bspark_portal_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function descargarExcel(path, nombre) {
  const { data } = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(data);
  const a = document.createElement("a");
  a.href = url;
  a.download = nombre;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Algo ha ido mal. Inténtalo de nuevo.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

/** Minúsculas y sin tildes: así «uxia» encuentra a «Uxía». */
export const sinAcentos = (texto) =>
  String(texto ?? "").normalize("NFD").replace(/\p{Mn}/gu, "").toLowerCase();

/** ¿El texto contiene lo buscado, ignorando tildes y mayúsculas? */
export const coincide = (texto, consulta) => {
  const q = sinAcentos(consulta).trim();
  return !q || sinAcentos(texto).includes(q);
};

export function fileUrl(fileId, portal = false) {
  const token = localStorage.getItem(portal ? "bspark_portal_token" : "bspark_token");
  return `${API}/files/${fileId}?auth=${token}`;
}

export const NIVELES = [
  { key: "naranja", label: "Nivel naranja", dot: "bg-orange-500", text: "text-orange-600" },
  { key: "amarillo", label: "Nivel amarillo", dot: "bg-amber-400", text: "text-amber-600" },
  { key: "verde", label: "Nivel verde", dot: "bg-emerald-500", text: "text-emerald-600" },
  { key: "azul", label: "Nivel azul", dot: "bg-blue-500", text: "text-blue-600" },
];

export const nivelInfo = (key) => NIVELES.find((n) => n.key === key) || NIVELES[0];

export const ESTADO_PAGO = {
  al_dia: { label: "Al día", cls: "bg-emerald-500/15 text-emerald-600 border-emerald-500/30" },
  pendiente: { label: "Pendiente", cls: "bg-amber-500/15 text-amber-600 border-amber-500/30" },
  impago: { label: "Impago", cls: "bg-destructive/15 text-destructive border-destructive/30" },
  cancelado: { label: "Cancelado", cls: "bg-muted text-muted-foreground border-border" },
};
